// extracted by mini-css-extract-plugin
module.exports = {"container":"ShapesBackground_container__1rs2K","child":"ShapesBackground_child__1mjeh"};